<pmt-action-modal [title]="'assignmentSchedules.addition.edit' | transloco" [onlyCancel]="false"
    [cancelButtonText]="'modal.cancelButton' | transloco" [submitButtonText]="'modal.saveButton' | transloco"
    [submitButtonIconCode]="''" (submitted)="save()" [isSaving]="isLoading">

    <form [formGroup]="answerAdditionForm" *ngIf="answerAdditionForm">
        <div class="d-flex flex-column gap-2">
            <div *ngIf="isWishCountActive">
                <label for="subject">{{'assignmentSchedules.addition.wishCount' | transloco}}</label>
                <input id="subject" type="number" min="0.5" step="0.5" formControlName="wishCount" class="form-control"
                    halfStep [disabled]="isLoading" />
            </div>

            <div>
                <label for="email">{{'assignmentSchedules.addition.comment' | transloco}}</label>
                <textarea id="email" formControlName="comment" rows="5" class="form-control"
                    [disabled]="isLoading"></textarea>
            </div>
        </div>
    </form>

</pmt-action-modal>